import { BorderRadius } from "@genesys/ui-elements";
import * as React from "react";
import styled from "styled-components";

const Container = styled.ul`
  display: flex;
  list-style: none;
  max-width: 400px;
  overflow-x: auto;

  li:first-child > input {
    border-top-left-radius: ${BorderRadius.compact};
  }

  li:last-child > input {
    border-top-right-radius: ${BorderRadius.compact};
  }
`;

export function TabContainer({
  children,
  selectedTabIndex
}: {
  readonly children: React.ReactNode;
  readonly selectedTabIndex: number;
}) {
  const containerRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const tabs = container.children;

    if (selectedTabIndex < 0 || selectedTabIndex >= tabs.length) {
      return;
    }

    const selectedTab = tabs[selectedTabIndex] as HTMLElement;
    if (!selectedTab) {
      return;
    }

    // Get relative position
    const { left } = getRelativePosition(selectedTab, container);

    if (isScrollbarVisible(container)) {
      const containerCenter = container.clientWidth / 2;
      const tabCenter = left + selectedTab.offsetWidth / 2;

      container.scrollLeft += tabCenter - containerCenter;
    }
  });

  return <Container ref={containerRef as any}>{children}</Container>;
}

interface ScrollbarVisibilityChecker {
  (element: HTMLElement): boolean;
}

const isScrollbarVisible: ScrollbarVisibilityChecker = element => {
  return element.scrollWidth > element.clientWidth;
};

function getRelativePosition(child: HTMLElement, parent: HTMLElement) {
  const childRect = child.getBoundingClientRect();
  const parentRect = parent.getBoundingClientRect();

  return {
    left: childRect.left - parentRect.left,
    top: childRect.top - parentRect.top
  };
}
